import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  Grid,
  Grow,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
import { QuotesForm } from "./QuotesForm";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import { ListSkeleton } from "components/listSkeleton";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import React from "react";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import { getAllQuoteDetails } from "redux/actions/quoteActions";
import style from "./index.module.scss";
import { BulkUploadForm } from "./BulkUploadForm";
import { MenuProps } from "styles/global.styles";
interface State {
  editing?: boolean;
  editItem?: any;
  lang?: number;
}

export default function QuotesScreen(): ReactElement {
  const languageType = [
    "defaultcontent",
    "en",
    "hi",
    "te",
    "gu",
    "ta",
    "ka",
    "mr",
    "it",
    "ru",
    "es",
    "fr",
    "pt",
    "de",
    "bn",
    "ml",
    "uk",
    "od",
    "enUs",
    "enAu",
    "pa",
    "ja"
  ];

  const dispatch = useDispatch();
  const quoteList = useSelector((state: RootState) => state.quote.quoteList);
  const languages = useSelector((state: RootState) => state.app.languages);
  const initialState: State = {
    editing: false,
    editItem: null,
    lang: 1,
  };

  const [language, setLanguage] = useState<any>(1);

  const [states, setStates] = useState<State>(initialState);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [searchQuote, setSearchQuote] = useState("");
  const [searchData, setsearchData] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setSearchQuote("");
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setSearchQuote("");
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onClickBack = () => {
    setCurrentIndex(0);
    setSearchQuote("");
    setStates({
      editing: false,
      editItem: null,
      lang: language,
    });
  };

  useEffect(() => {
    dispatch(getAllQuoteDetails({ pageSize: rowsPerPage, pageNumber: page }));
  }, [dispatch, page, rowsPerPage, language]);

  const renderQuoteList = (data: any) => {
    return (
      <div>
        {data.length ? (
          <>
            <Grid
              style={{ backgroundColor: "transparent" }}
              className="d-flex py-2 pl-3 align-items-center"
            >
              <Grid className="d-flex flex-grow-1">
                <TextField
                  type="search"
                  fullWidth
                  value={searchQuote}
                  variant="outlined"
                  placeholder="Search quote by author"
                  size="small"
                  onChange={e => {
                    setSearchQuote(e.target.value);
                    const filteredData = data.filter((item: any) =>
                      item.author[languageType[language - 1]]
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()),
                    );
                    setsearchData(filteredData);
                  }}
                  className="mr-2"
                />
              </Grid>
              <Grid className="d-flex align-items-center">
                <IconButton
                  onClick={() => {
                    dispatch(
                      getAllQuoteDetails({
                        pageSize: rowsPerPage,
                        pageNumber: page,
                      }),
                    );
                  }}
                  size="large"
                >
                  <Tooltip title="Refresh">
                    <RefreshIcon />
                  </Tooltip>
                </IconButton>
              </Grid>
            </Grid>
            <TableContainer
              style={{ maxHeight: "400px" }}
              // className={style.scrollbar}
            >
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow style={{ fontWeight: "bold" }}>
                    <TableCell align="center">Author</TableCell>
                    <TableCell align="center">Quote</TableCell>
                    <TableCell align="center">Tag 1</TableCell>
                    <TableCell align="center">Tag 2</TableCell>
                    <TableCell align="center">Tag 3</TableCell>
                    <TableCell align="center">Screen</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(searchQuote !== "" ? searchData : data).map((item: any, x: any) => (
                    <React.Fragment key={x}>
                      <TableRow
                        sx={{ cursor: "pointer", height: "50px" }}
                        hover
                        onClick={() => {
                          setStates({
                            editing: true,
                            editItem: item,
                            lang: language,
                          });
                          setCurrentIndex(1);
                        }}
                      >
                        <TableCell align="center">
                          {item.author[languageType[language - 1]]
                            ? item.author[languageType[language - 1]]
                            : item.author[languageType[0]]}
                        </TableCell>
                        <TableCell align="center">
                          {(item.quote[languageType[language - 1]]
                            ? item.quote[languageType[language - 1]]
                            : item.quote[languageType[0]]
                          )?.slice(0, 20)}
                          {(item.quote[languageType[language - 1]]
                            ? item.quote[languageType[language - 1]]
                            : item.quote[languageType[0]]
                          )?.length > 20 && "..."}
                        </TableCell>
                        <TableCell align="center">{item.tagone}</TableCell>
                        <TableCell align="center">{item.tagtwo}</TableCell>
                        <TableCell align="center">{item.tagthree}</TableCell>
                        <TableCell align="center">{item.screen}</TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={quoteList.quotes.pageable.totalcount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
              className={style.scrollbar}
            />
          </>
        ) : (
          <Box height={350}>
            <Grid
              container
              style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No quotes to show
              </Typography>
            </Grid>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Container>
      {quoteList.loading && (
        <CircularProgress style={{ position: "absolute", top: "50%", right: "50%" }} />
      )}
      <Grid container>
        <Grid item xs={12}>
          <Card className="mt-3 mb-5">
            <Grow
              in={currentIndex === 0}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 0 ? { timeout: 1000 } : {})}
            >
              <div>
                <Grid container className="align-items-center p-3" spacing={2}>
                  <Grid item>
                    <Typography variant="h6">Quotes</Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setCurrentIndex(1);
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Quote
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setCurrentIndex(2);
                      }}
                      startIcon={<AddIcon />}
                    >
                      Bulk Upload
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={4} md={4} lg={3}>
                  <FormControl variant="outlined" className="m-3" fullWidth>
                    <InputLabel id="language-select">Language</InputLabel>
                    {languages && (
                      <Select
                        defaultValue=""
                        labelId="language-select"
                        value={language}
                        label="Language"
                        onChange={e => {
                          setLanguage(e.target.value as number);
                        }}
                        MenuProps={MenuProps}
                      >
                        {languages.map((lang: any, i: any) => (
                          <MenuItem key={i} value={lang.code}>
                            {lang.displayName}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Divider />
                <CardContent>
                  <Paper>
                    {quoteList.loading
                      ? ListSkeleton()
                      : renderQuoteList(quoteList.quotes.quotedetailsList)}
                  </Paper>
                </CardContent>
              </div>
            </Grow>
            <Grow
              in={currentIndex === 1}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 1 ? { timeout: 1000 } : {})}
            >
              <QuotesForm
                isEditing={states.editing}
                editItem={states.editItem}
                onClickBack={onClickBack}
                lang={language}
                getAllQuoteData={{
                  pageNumber: page,
                  pageSize: rowsPerPage,
                }}
              />
            </Grow>{" "}
            <Grow
              in={currentIndex === 2}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 2 ? { timeout: 1000 } : {})}
            >
              <BulkUploadForm
                onClickBack={onClickBack}
                getAllQuoteData={{
                  pageNumber: page,
                  pageSize: rowsPerPage,
                }}
              />
            </Grow>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
